module.exports = __webpack_public_path__ + "static/Product-Summary-P1.667-Indoor-d8bb043a9b68b975daa24278e0a82c6c.jpg";